import React, { useState, useContext, lazy, Suspense } from 'react';
import { UserContext } from '../App';
import './app_styling.css';
import { IconContext } from 'react-icons';
import { FaHome, FaVideo } from 'react-icons/fa';
import { GiPodiumWinner } from 'react-icons/gi';
import { MdOutlineAccountCircle } from 'react-icons/md';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { BsPlusLg, BsCashCoin } from 'react-icons/bs';
const UploadVideoImage = lazy(() => import('./UploadVideoImage'));

export default function MainNavigationMenu() {
  const user = useContext(UserContext);
  const [uploadOpen, setUploadOpen] = useState(false);
  const uploadIcon = <div className="links" id="post-link"><div className="post-upload"><BsPlusLg /></div></div>;
  return <IconContext.Provider value={{ size: '1.1em', color: 'currentColor' }}>
    <nav className="main-navigation-menu" aria-label="Main navigation">
      <div className="mobile-nav-surface" aria-hidden="true">
        <span />
        <svg viewBox="0 0 96 64" preserveAspectRatio="none"><path d="M0 0 C12 0 14 4 18 14 C24 30 34 34 48 34 C62 34 72 30 78 14 C82 4 84 0 96 0 V64 H0 Z" /><path className="nav-notch-edge" d="M0 .5 C12 .5 14 4.5 18 14.5 C24 30.5 34 34.5 48 34.5 C62 34.5 72 30.5 78 14.5 C82 4.5 84 .5 96 .5" /></svg>
        <span />
      </div>
      <div className="mobile-nav-group mobile-nav-left">
        <ComponentLink to="/" label="Home"><FaHome /></ComponentLink>
        <ComponentLink to="/wallOfFame" label="Top memes"><GiPodiumWinner /></ComponentLink>
      </div>
      {user ? <button type="button" id="upload-link" aria-label="Upload" aria-haspopup="dialog" onClick={() => setUploadOpen(true)}>{uploadIcon}</button>
        : <Link to="/account" id="upload-link" aria-label="Upload">{uploadIcon}</Link>}
      <div className="mobile-nav-group mobile-nav-right">
        <ComponentLink to="/memeBattle" label="Battles"><BsCashCoin /></ComponentLink>
        <ComponentLink to="/videosPage" label="Videos"><FaVideo /></ComponentLink>
        <ComponentLink to="/account" label="Account"><MdOutlineAccountCircle /></ComponentLink>
      </div>
    </nav>
    {uploadOpen && <Suspense fallback={<div role="status">Opening upload…</div>}><UploadVideoImage closePostUploadModal={setUploadOpen} /></Suspense>}
  </IconContext.Provider>;
}
function ComponentLink({ to, label, children }) {
  const resolved = useResolvedPath(to);
  const active = useMatch({ path: resolved.pathname, end: true });
  return <Link to={to} className={active ? 'main-active' : ''} aria-current={active ? 'page' : undefined}><div className="links"><div>{children}</div><div>{label}</div></div></Link>;
}
